$(document).ready(function () {
	customFilterMobileDropdown();
	initEvents();
	initCustomBorders();
	offersDetailAccordion();
	customOffCanvas();
	initDateSelection();
	checkForDropdownOffers();
	// customCookieBar();
	customLoyaltyLogin();
	initScroll();
	initShoreditchLanding();
	shoreditchDropdownOffers();
	shoreditchDetails();
	initScroll();
	customForms();
	initVideoPopups();
	initRoomCarousel();
	initGHAPortal();
	accessibleNavigation();
});

var initOffCanvas = function () {

	$('.off-canvas__nav-primary > ul > li').each(function () {
		// Automatically add the "Overview" links to the landing page
		if ( $(this).find('ul').length > 0 ) {
			var $toggle = $(this).find('a').first();
			$toggle.attr('aria-role', 'button');
			$toggle.attr('aria-expanded', 'true');
			$toggle.attr('aria-label', 'Toggle ' + $toggle.text());
			
			$toggle.on('keydown', function (event) {
				if (event.which === 32) {
					$toggle.trigger('click');
					$toggle.attr('aria-expanded', 'false');
				}
			})

			if ($('body').hasClass('theme-lyle') === false) {
				var overviewLink = $toggle.attr('href');
				$(this).find('ul').prepend('<li class="offcanvas__overview-link"><a href="' + overviewLink + '">Overview</a></li>');
			}
		}
	});

	$('.off-canvas__nav-primary > ul > li > a').on('click', function () {
		if ( $(this).next('.off-canvas__nav-sub').length > 0 ) { // only trigger if there are sub pages to show
			if ( $(this).parent().hasClass('open') ) {
				// second click of main item allows clicking directly through
				return true;
			} else {
				// close any other open items
				$('.off-canvas__nav-primary > ul > li.open').removeClass('open').find('.off-canvas__nav-sub').slideUp().attr("aria-expanded", "false")
				// and open the new one
				$(this).parent().addClass('open');
				$(this).next().slideDown().attr("aria-expanded", "true");
			}
			return false; // prevent navigating
		}
	});
}

var initScroll = function () {

	$('.scroller').on('click', function () {

		$('html, body').animate({
			scrollTop: $( '.slider' ).outerHeight() - 112
		}, 750);
	});

}



var initFeaturedCarousel = function () {
	$('.featured-carousel__inner').slick({
		dots: true,
		arrows: true,
		slidesToShow: 1,
		slidesToScroll: 1
	})
}

var initSlider = function () {
	$('.slider').each(function () {
		if ( $(this).find('.slider__slide').length > 1 ) {
			$(this).addClass('has-slider-dots');
		}
	});



	$('.slider__inner').reformSlider({
		autoPlay: true,
		speed: Number($('.slider__inner').data("scroll-speed")),
		arrows: true,
		pagination: true,
		onLoad: function () {
			$('.has-mixed-media').addClass('show')
		}

	});



	if ( $('.slider__slide iframe').length > 0 ) {
		$('.slider').addClass('has-video');

		if ( $('body').hasClass('seed') ) {
			$('.slider__slide iframe').attr('width', '1920').attr('height', '1080');
		}
		coverViewport('.slider__slide iframe', true);
		$(window).on('resize', function () {
			coverViewport('.slider__slide iframe', true);
		});
	}
};


var initLandingSlider = function () {
	$('.landing__slider-inner').slick({
		fade: true,
		arrows: true,
		autoplay: false
	});

	if ( ($('.landing__row').last().hasClass('landing__row--light-background')) || ($('.landing__row').last().hasClass('landing__row--dark-background')) ) {
		$('.landing').addClass('landing--last-item-has-background-color');
	}

	if ( $('.landing__slider-inner').length > 0 ) {
		$(window).on('resize', function () {
			setTimeout(function () {
				$('.landing__slider-inner').slick('refresh');
			}, 1000);
		});
	}
};


var initAnimateInView = function () {
	$(window).on('DOMContentLoaded load resize scroll', animateElementsInView);
	animateElementsInView();
}

function animateElementsInView() {
	$('[data-animate-in-view]').each(function () {
		if ( $(this).hasClass('in-view') ) {
			return;
		}

		if ( isElementInViewport($(this)) ) {
			var elementToAnimate = this;

			$(elementToAnimate).addClass('in-view'); // log that this element has been seen


			setTimeout(function () {
				$(elementToAnimate).addClass( $(elementToAnimate).data('animate-in-view') ); // apply the animation class
				$(elementToAnimate).removeClass( $(elementToAnimate).data('animate-in-view-remove-class') ); // remove the pre-animation class
			}, 300);


			if ( typeof $(elementToAnimate).data('map-load-on-view') != 'undefined' ) { // only load this map once it's in view
				buildMap(elementToAnimate);
			}
		}
	});
}

// https://stackoverflow.com/questions/123999/how-to-tell-if-a-dom-element-is-visible-in-the-current-viewport
function isElementInViewport (el) {
	//special bonus for those using jQuery
	if (typeof jQuery === "function" && el instanceof jQuery) {
		el = el[0];
	}

	var rect = el.getBoundingClientRect();

	return (
		rect.top <=  $(window).scrollTop() + window.innerHeight
	);
}


var initMaps = function () {
	$('[data-map]').each(function () {
		buildMap(this);
	});
}

function buildMap(mapContainer) {
	var $mapContainer = $(mapContainer);
	var map, centerLat, centerLng, zoom, marker, markerLat, markerLng;

	if (typeof $mapContainer.data('map-center-coords') != 'undefined') {
		centerLat = parseFloat( $mapContainer.data('map-center-coords').split(',')[0] );
		centerLng = parseFloat( $mapContainer.data('map-center-coords').split(',')[1] );
	} else {
		centerLat = 0;
		centerLng = 0;
	}

	zoom = $mapContainer.data('map-zoom') || 8;

	map = new google.maps.Map($mapContainer[0], {
		center: {lat: centerLat, lng: centerLng},
		zoom: zoom,
		zoomControl: true,
		zoomControlOptions: {
			style: google.maps.ZoomControlStyle.SMALL,
			position: google.maps.ControlPosition.RIGHT_CENTER
		},
		mapTypeControl: false,
		scaleControl: false,
		streetViewControl: false,
		rotateControl: false,
		fullscreenControl: false,
		styles: mapDarkStyle
	});

	if (typeof $mapContainer.data('map-marker-coords') != 'undefined') {
		if (typeof $mapContainer.data('map-marker-coords') != 'undefined') {
			markerLat = parseFloat( $mapContainer.data('map-marker-coords').split(',')[0] );
			markerLng = parseFloat( $mapContainer.data('map-marker-coords').split(',')[1] );
		} else {
			markerLat = 0;
			markerLng = 0;
		}

		marker = new google.maps.Marker({
			position: {lat: markerLat, lng: markerLng},
			map: map
		});

		if (typeof $mapContainer.data('map-marker-url') != 'undefined') {
			marker.setIcon({
				url: $mapContainer.data('map-marker-url'),
				origin: new google.maps.Point(0,0),
				anchor: new google.maps.Point(62,0)
			});
		}
	}




	$mapContainer.siblings('[data-map-marker]').each(function () {
		if (typeof $(this).data('map-marker-coords') != 'undefined') {
			markerLat = parseFloat( $(this).data('map-marker-coords').split(',')[0] );
			markerLng = parseFloat( $(this).data('map-marker-coords').split(',')[1] );
		} else {
			markerLat = 0;
			markerLng = 0;
		}

		marker = new google.maps.Marker({
			position: {lat: markerLat, lng: markerLng},
			map: map
		});

		if (typeof $(this).data('map-marker-url') != 'undefined') {
			marker.setIcon($(this).data('map-marker-url'));
		}
	});


	var old_v='',
		ds=new google.maps.DirectionsService(),
		dr=new google.maps.DirectionsRenderer();
	  dr.setMap(map);
	  dr.setPanel(jQuery('#map-directions-data').get(0))

	$('.location__form').on('submit', function (e) {
		e.preventDefault();

		var v=jQuery.trim( $('input[name="directions_from"]').val() );

		var directionsTo = $('input[name="directions_to"]').val();

		if(v!=''&&v!=old_v){
			old_v=v;

			var r = {
				origin:v,
				destination: directionsTo,
				travelMode: google.maps.TravelMode.DRIVING,
				unitSystem: google.maps.UnitSystem.IMPERIAL
			};

			ds.route(r, function(result, status){

				if (status == google.maps.DirectionsStatus.OK) {
					marker.setMap(null);
					dr.setDirections(result);

					setTimeout(function () {
						var x = document.getElementById("map-directions-data").innerHTML;
						var str = x;
						str = str.replace(/&/g, "amp;");
						str = str.replace(/>/g, "gt;");
						str = str.replace(/</g, "lt;");
						str = str.replace(/"/g, "quot;");
						str = str.replace(/'/g, "#039;");
					},2000);
				} else {
					console.log(result, status);
					alert('Location ' + old_v + ' not found.');
				}
			});
		}
	});
}

if( $('body.theme-100-shoreditch') ) {
	var mapDarkStyle = [{"featureType":"administrative","elementType":"geometry","stylers":[{"color":"#f2ecdb"}]},{"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"visibility":"on"},{"color":"#7a0026"}]},{"featureType":"landscape","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#f2ecdb"}]},{"featureType":"poi","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#eedeb0"}]},{"featureType":"poi","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"labels.text.fill","stylers":[{"color":"#282828"}]},{"featureType":"road","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"visibility":"on"},{"color":"#c3c3c3"}]},{"featureType":"road.arterial","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"road.arterial","elementType":"geometry.stroke","stylers":[{"color":"#d6d6d6"}]},{"featureType":"road.local","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"weight":1.8}]},{"featureType":"road.local","elementType":"geometry.stroke","stylers":[{"color":"#d7d7d7"}]},{"featureType":"transit","elementType":"all","stylers":[{"color":"#808080"},{"visibility":"off"}]},{"featureType":"water","elementType":"geometry.fill","stylers":[{"color":"#b5dee8"}]}]
} else {
	var mapDarkStyle = [{featureType:"administrative",elementType:"labels",stylers:[{saturation:100},{lightness:34},{visibility:"on"}]},{featureType:"administrative",elementType:"labels.text.fill",stylers:[{color:"#000000"}]},{featureType:"landscape.man_made",elementType:"geometry.fill",stylers:[{visibility:"on"},{saturation:"50"},{color:"#e4dfd9"}]},{featureType:"landscape.natural",elementType:"geometry.fill",stylers:[{visibility:"on"},{color:"#bcbca0"}]},{featureType:"poi",elementType:"all",stylers:[{hue:"#ffffff"},{saturation:-100},{lightness:100},{visibility:"off"}]},{featureType:"road",elementType:"geometry",stylers:[{hue:"#ffffff"},{saturation:-100},{lightness:100},{visibility:"simplified"}]},{featureType:"road",elementType:"labels.icon",stylers:[{saturation:"-100"},{lightness:"27"},{visibility:"on"}]},{featureType:"road.highway",elementType:"geometry",stylers:[{hue:"#deecec"},{saturation:-73},{lightness:72},{visibility:"on"}]},{featureType:"road.highway",elementType:"geometry.fill",stylers:[{visibility:"on"}]},{featureType:"road.highway",elementType:"labels",stylers:[{saturation:-100},{lightness:25},{visibility:"on"}]},{featureType:"road.highway",elementType:"labels.text",stylers:[{lightness:"0"},{visibility:"on"}]},{featureType:"road.highway.controlled_access",elementType:"labels.text.fill",stylers:[{visibility:"off"}]},{featureType:"road.arterial",elementType:"labels",stylers:[{visibility:"on"}]},{featureType:"road.arterial",elementType:"labels.text.fill",stylers:[{lightness:"-25"}]},{featureType:"road.local",elementType:"labels",stylers:[{visibility:"off"}]},{featureType:"road.local",elementType:"labels.text",stylers:[{visibility:"on"}]},{featureType:"road.local",elementType:"labels.text.fill",stylers:[{saturation:"0"},{lightness:"35"},{visibility:"on"},{color:"#2c2c2c"}]},{featureType:"transit",elementType:"all",stylers:[{hue:"#ffffff"},{lightness:100},{visibility:"off"}]},{featureType:"water",elementType:"all",stylers:[{saturation:100},{lightness:-5},{visibility:"on"},{color:"#ffffff"}]},{featureType:"water",elementType:"geometry.fill",stylers:[{color:"#585c3b"}]}];
}

function initEvents() {
	$('.events__carousel-inner').each(function () {
		$(this).addClass('item-count-' + $(this).find('.events__item').length);
	});

	if( $('body.theme-100-shoreditch').length > 0 ) {
		$('.events__carousel-inner.shoreditch').slick({
			slidesToShow: 4,
			arrows: true,
			appendArrows: '.events__header',
			infinite: true,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 2
					}
				},
				{
					breakpoint: 640,
					settings: {
						slidesToShow: 1
					}
				}
			]
		});
	} else {
		$('.events__carousel-inner').slick({
			slidesToShow: 2,
			arrows: true,
			responsive: [
				{
					breakpoint: 640,
					settings: {
						slidesToShow: 1
					}
				}
			]
		});
	}

	$('.promo-slider-inner').slick({
		fade: true,
		arrows: true,
		autoplay: false
	});
}

function initRoomCarousel() {
	$('.rooms__carousel-inner').each(function () {
		$(this).addClass('item-count-' + $(this).find('.rooms__item').length);
	});

	if( $('body.theme-100-shoreditch').length > 0 ) {
		$('.rooms__carousel-inner.shoreditch').slick({
			slidesToShow: 4,
			arrows: true,
			appendArrows: '.rooms__header',
			infinite: true,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 2
					}
				},
				{
					breakpoint: 640,
					settings: {
						slidesToShow: 1
					}
				}
			]
		});
	} else {
		$('.rooms__carousel-inner').slick({
			slidesToShow: 2,
			arrows: true,
			responsive: [
				{
					breakpoint: 640,
					settings: {
						slidesToShow: 1
					}
				}
			]
		});
	}

}


function customFilterMobileDropdown() {
	if ( $('.gallery').length === 0 ) return;

	var filterWatcher = setInterval(function () {
		if ( $('.filter-controls-dropdown select').length === 1 ) {
			clearInterval(filterWatcher);
		}
		$('.filter-controls-dropdown select').selectric();
		$('.selectric-input').wrap("<label hidden aria-hidden='true'>Hidden Label</label>")

	}, 500);
}

function offersDetailAccordion() {
	$('.offers-detail__accordion').accordiom({
		showFirstItem: false
	})
}


var initOtherRooms = function () {
	$('.other-rooms__carousel').slick({
		dots: true,
		arrows: true,
		slidesToShow: 3,
		slidesToScroll: 1,
		centerMode: true,
		centerPadding: 0,
		infinite: true,
		responsive: [
			{
				breakpoint: 640,
				settings: {
					slidesToShow: 1,
					adaptiveHeight: true
				}
			}
		]
	});
}


var initAccommodation = function () {
	$('.accommodation__slider-inner').slick({
		fade: true,
		arrows: true,
		autoplay: false
	});

	// Apply odd/even styles that skip any quote or other sections added in between
	var i = 1;
	$('.accommodation__item').each(function () {
		if ( i < 0 ) {
			$(this).addClass('accommodation__item--odd');
		}

		i = i*-1;
	});
}



function initCustomBorders() {
	$('.chamfered-border').append('<canvas style="width: 100%; height: 100%; position: absolute; top: 0; left: 0; pointer-events: none;"></canvas>');
	$('.direct-inner').append('<canvas id="canvas-border"></canvas>');
	$('.loyalty-panel').append('<canvas style="width: 100%; height: 100%; position: absolute; top: 0; left: 0; pointer-events: none; z-index: -1;"></canvas>');
	drawCustomBorder();
	$(window).on('resize', drawCustomBorder);
	drawCustomBorder2();
	$(window).on('resize', drawCustomBorder2);
	drawCustomBorder3();
	$(window).on('resize', drawCustomBorder3);

}

function drawCustomBorder() {
	$('.chamfered-border canvas').each(function () {
		var borderColor = window.getComputedStyle( document.getElementsByTagName('h1')[0] ).getPropertyValue("color");
		if ( $(this).parent().hasClass('chamfered-border--white') ) {
			borderColor = '#fff';
		}

		$(this).attr('width', $(this).outerWidth());
		$(this).attr('height', $(this).outerHeight());

		canvas = $(this)[0];

		if (canvas.getContext) {
			var canvasW = canvas.getBoundingClientRect().width;
			var canvasH = canvas.getBoundingClientRect().height;
			var ctx = canvas.getContext('2d');

			ctx.strokeStyle = borderColor;
			ctx.lineWidth = 1;


			ctx.beginPath();
			ctx.moveTo(0.5, 30.5);
			ctx.lineTo(30 + 0.5, 0 + 0.5);
			ctx.lineTo(canvasW - 30.5, 0.5);
			ctx.lineTo(canvasW - 0.5, 30.5);
			ctx.lineTo(canvasW - 0.5, canvasH - 30.5);
			ctx.lineTo(canvasW - 30.5 , canvasH - 0.5);
			ctx.lineTo(30.5 , canvasH - 0.5);
			ctx.lineTo(0.5 , canvasH - 30.5);
			ctx.lineTo(0.5, 30.5);
			ctx.stroke();
		}
	});
}

function drawCustomBorder2() {
	$('.direct-inner canvas').each(function () {

		$(this).attr('width', $(this).outerWidth());
		$(this).attr('height', $(this).outerHeight());

		canvas = $(this)[0];

		if (canvas.getContext) {
			var canvasW = canvas.getBoundingClientRect().width;
			var canvasH = canvas.getBoundingClientRect().height;
			var ctx = canvas.getContext('2d');

			ctx.strokeStyle = '#5E7461';
			ctx.lineWidth = 1;
			// ctx.fillStyle = 'transparent';


			ctx.beginPath();
			ctx.moveTo(0.5, 30.5);
			ctx.lineTo(30 + 0.5, 0 + 0.5);
			ctx.lineTo(canvasW - 30.5, 0.5);
			ctx.lineTo(canvasW - 0.5, 30.5);
			ctx.lineTo(canvasW - 0.5, canvasH - 30.5);
			ctx.lineTo(canvasW - 30.5 , canvasH - 0.5);
			ctx.lineTo(30.5 , canvasH - 0.5);
			ctx.lineTo(0.5 , canvasH - 30.5);
			ctx.lineTo(0.5, 30.5);
			ctx.stroke();
		}
	});
}

function drawCustomBorder3() {
	$('.loyalty-panel canvas').each(function () {

		$(this).attr('width', $(this).outerWidth());
		$(this).attr('height', $(this).outerHeight());

		canvas = $(this)[0];

		if (canvas.getContext) {
			var canvasW = canvas.getBoundingClientRect().width;
			var canvasH = canvas.getBoundingClientRect().height;
			var ctx = canvas.getContext('2d');

			ctx.strokeStyle = '#5E7461';
			ctx.lineWidth = 1;
			ctx.fillStyle = '#5E7461';


			ctx.beginPath();
			ctx.moveTo(0.5, 30.5);
			ctx.lineTo(30 + 0.5, 0 + 0.5);
			ctx.lineTo(canvasW - 30.5, 0.5);
			ctx.lineTo(canvasW - 0.5, 30.5);
			ctx.lineTo(canvasW - 0.5, canvasH - 30.5);
			ctx.lineTo(canvasW - 30.5 , canvasH - 0.5);
			ctx.lineTo(30.5 , canvasH - 0.5);
			ctx.lineTo(0.5 , canvasH - 30.5);
			ctx.lineTo(0.5, 30.5);
			ctx.fill();
			ctx.stroke();
		}
	});
}


function customOffCanvas() {

	if ( $('.off-canvas__offer').length > 0 ) {
		$('.off-canvas').addClass('off-canvas--has-offer');
	} else {
		$('.off-canvas__sidebar').remove();
	}

	trapFocus(document.querySelector('#offCanvas'));

	$('.header__off-canvas-toggle').on('click', function () {
		document.querySelector(focusableElementsSelector).focus();
	});

	$('.off-canvas__close').on('click', function () {
		document.querySelector('.header__off-canvas-toggle').focus();
	});
}

function openBookingRoom () {

}


function initDateSelection() {
	// $('#booking').foundation('open');

	// Only load 3rd party iframes when the booking widget is toggled
	function loadIframes() {
		$('.booking iframe').each(function () {
			if ( typeof $(this).data('src') !== 'undefined' ) {
				$(this).attr('src', $(this).data('src'));
			}
		});
	}

	$('.header__cta button').on('click', function () {
		loadIframes();
		$(window).trigger('resize'); // rejig the equalizer for the date fields
	});



	/* Open the booking widget and switch to the book table tab

	$('#book-table-btn').on('click', function () {
		$('#book-rooms').css("display", 'none')
		$('#book-rooms').css("pointer-evetns", 'none')
		$('.booking__tabs-direct').css("display", 'none');

		$('#book-table').show();
		$('#booking').foundation('open');
		$('#nav-book-table').css('background-color', '#7A0026')
	});

	$('a[href*="#bookTable"]').on('click', function () {
		loadIframes();

		$('#book-rooms').css("display", 'none')
		$('#book-rooms').css("pointer-evetns", 'none')
		$('.booking__tabs-direct').css("display", 'none');

		$('#book-table').show();
		$('#booking').foundation('open');
		$('#nav-book-table').css('background-color', '#7A0026')
		$('#nav-book-room').css('background-color', '#000')
	})

	$('#nav-book-table').on('click', function () {

		$('#book-rooms').css("display", 'none')
		$('#book-rooms').css("pointer-evetns", 'none')
		$('.booking__tabs-direct').css("display", 'none');


		$('#book-table').show();
		$('#booking').foundation('open');
		$('#nav-book-table').css('background-color', '#7A0026')
		$('#nav-book-room').css('background-color', '#000')
	})

*/

	$('#book-room-btn').on('click', function () {
		/*$('#book-rooms').css("display", 'block')
		$('#book-rooms').css("pointer-evetns", 'all')
		$('.booking__tabs-direct').css("display", 'block');

		$('#book-table').hide();
		$('#booking').foundation('open');
		$('#nav-book-room').css('background-color', '#7A0026')*/

		$('#book-rooms form').trigger('submit');
	})

	$('#nav-book-room').on('click', function () {
		$('#book-rooms').css("display", 'block')
		$('#book-rooms').css("pointer-evetns", 'all')
		$('.booking__tabs-direct').css("display", 'block');

		$('#book-table').hide();
		$('#booking').foundation('open');
		$('#nav-book-room').css('background-color', '#7A0026')
		$('#nav-book-table').css('background-color', '#000')
	})


	// Hide any open date pickers when changing tab
	$('#booking-tabs').on('change.zf.tabs', function () {
		$('.datepicker-container').addClass('datepicker-hide');
	});

	var bookingContainer = $('.booking__tabs-content-room form');

	var nowTemp = new Date();
	// Don't allow bookings until the hotel opens
	if ( (nowTemp < new Date('2022-03-01')) && ($('body').hasClass('theme-100-shoreditch')) )  {
		nowTemp = new Date('2022-03-01');
	}


	/*var tomorrow = new Date();
		tomorrow.setDate(nowTemp.getDate() + 1);*/

	var tomorrow = new Date(nowTemp.getTime() + 86400000); // + 1 day in ms
	tomorrow.toLocaleDateString();

	var $checkInField = bookingContainer.find('.check-in');
	var $checkOutField = bookingContainer.find('.check-out');

	$checkInField.on('hide.datepicker', function () {
		var checkInDate  = $checkInField.datepicker('getDate');
		var checkOutDate = $checkOutField.datepicker('getDate');
		var dayAfterCheckIn = new Date(checkInDate);
			dayAfterCheckIn.setDate(checkInDate.getDate() + 1);

		// Ensure checkout comes after checkin.
		// Otherwise it all gets a bit Restaurant at the End of the Universe-ey.
		if ( checkInDate >= checkOutDate ) {
			$checkOutField.datepicker('setDate', dayAfterCheckIn);
		}

		$checkOutField.datepicker('setStartDate', dayAfterCheckIn);

		$checkOutField[0].focus();
	});

	if ( $('body').hasClass('theme-100-shoreditch') ) {

		var checkin = $checkInField.datepicker({
			format: 'dd-mm-yy',
			autoPick: true,
			autoHide: true,
			date: null,
			startDate: nowTemp,

			pick: function (e) {
				// Formatted date for the booking engine
				$('input[name="arrive"]').val( e.date.getFullYear() + '-' + pad( e.date.getMonth() + 1*1 , 2) + '-' + e.date.getDate() )			}
		});

		var checkout = $checkOutField.datepicker({
			format: 'dd-mm-yy',
			autoPick: true,
			autoHide: true,
			date: null,
			startDate: tomorrow,
			pick: function (e) {
				// Formatted date for the booking engine
				$('input[name="depart"]').val( e.date.getFullYear() + '-' + pad( e.date.getMonth() + 1*1 , 2) + '-' + e.date.getDate() );			}
		});

	} else {
		var checkin = $checkInField.datepicker({
			format: 'mm-dd-yy',
			autoPick: true,
			autoHide: true,
			date: null,
			startDate: nowTemp,

			pick: function (e) {
				// Formatted date for the booking engine
				$('input[name="datein"]').val( pad( e.date.getMonth() + 1*1 , 2) + '/' + e.date.getDate() + '/' + e.date.getFullYear() )
			}
		});

		var checkout = $checkOutField.datepicker({
			format: 'mm-dd-yy',
			autoPick: true,
			autoHide: true,
			date: null,
			startDate: tomorrow,
			pick: function (e) {
				// Formatted date for the booking engine
				$('input[name="dateout"]').val( pad( e.date.getMonth() + 1*1 , 2) + '/' + e.date.getDate() + '/' + e.date.getFullYear() );
			}
		});
	}


	$('.booking select').selectric();


	$('.booking__tabs-content-room-why-book').accordiom({
		showFirstItem: false
	});


	$('#booking__picker-select').on('change', function () {
		$('.tabs-panel').removeClass('is-active');
		$('#' + $(this).val()).addClass('is-active');
	});



	// Always open the booking widget for any booking links
	// $('a[href*="reservations.travelclick.com"], a[href*="reservations.lyledc.com"], a[href*="reservations.onehundredshoreditch.com"], a[href*="be.synxis.com"]').not('.reservations__item-cta a').on('click', function () {

	// 	//$('#booking').foundation('open');

	// 	// Auto populate the room or rate codes if present in the URL
	// 	if ( $(this).attr('href').indexOf('?') > -1 ) {
	// 		var urlParams = new URLSearchParams( $(this).attr('href').split('?')[1] );
	// 		if ( urlParams.has('RatePlanId') ) {
	// 			$('input[name="RatePlanId"]').val( urlParams.get('RatePlanId') );
	// 		}
	// 		if ( urlParams.has('Groupid') ) {
	// 			$('input[name="Groupid"]').val( urlParams.get('Groupid') );
	// 		}
	// 		if ( urlParams.has('RoomTypeID') ) {
	// 			$('#book-rooms form').append('<input type="hidden" name="RoomTypeID" value="' + urlParams.get('RoomTypeID') + '">');
	// 		}
	// 		if ( urlParams.has('promo') ) {
	// 			$('input[name="promo"]').val( urlParams.get('promo') );
	// 		}
	// 		if ( urlParams.has('rate') ) {
	// 			$('input[name="rate"]').val( urlParams.get('rate') );
	// 		}
	// 		if ( urlParams.has('room') ) {
	// 			$('input[name="room"]').val( urlParams.get('room') );
	// 		}
	// 	}

	// 	$('#book-rooms form').trigger('submit');

	// 	return false;

	// });
}

function pad(n, width, z) {
	z = z || '0';
	n = n + '';
	return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
}


function checkForDropdownOffers() {
	if( ($('.dropdown-offers').length > 0) && ($('.slider').length === 0) ) {
		$('.breadcrumb').css('padding-top', '167px');
	}
}




// function customCookieBar() {
// 	if ( $('.cookie-bar').length > 0 ) {
// 		if ( !Cookies.get('accepted_cookies') ) {
// 			$('.cookie-bar').fadeIn();
// 		}


// 		$('.cookie-bar__accept').on('click', function () {
// 			Cookies.set('accepted_cookies', 'true', {expires: 30});
// 			$('.cookie-bar').fadeOut();
// 		});
// 	}
// }



function customLoyaltyLogin() {
	$('.reservations__list--more').accordiom({
		showFirstItem: false,
		buttonBelowContent: true,
		afterChange: function(accordionButton) {
			var $accordionButton = $(accordionButton);
			if ( $accordionButton.hasClass('on') ) {
				$accordionButton.find('span').text( $accordionButton.data('less-text') );
			} else {
				$accordionButton.find('span').text( $accordionButton.data('more-text') );
			}
		}
	});

	$('.loyalty-offers__public-offers').accordiom({
		showFirstItem: false
	});
}

function initShoreditchLanding() {
	if( $('body.theme-100-shoreditch') && $('.landing__slider') ) {
		$('.coffee').find('.multiple-buttons a:first').addClass('button--white');
		$('.coffee').find('.landing__content').addClass('white');
		$('.lobby').find('.multiple-buttons a:first').addClass('button--white');
		$('.lobby').find('.landing__content').addClass('white');
	}
}

function shoreditchDropdownOffers() {
	if( $('body.theme-100-shoreditch').length > 0 ) {
		console.log('body class found');
		$('.header-offers button').click(function() {
			$('.dropdown-offers').addClass('on');
			$('.dropdown-offers .accordionButton').trigger('click');
			$('.dropdown-offers .accordionButton').css('display', 'none');
			$("#dropdown-offers-button").prop("ariaExpanded", "true");
		});

		$('.dropdown-offers__close').click(function() {
			$('.dropdown-offers').removeClass('on');
		})
	}
}

function shoreditchDetails() {
	$('.detail__slider-inner').slick({
		slidesToShow: 1,
		arrows: true
	})
}

function customForms() {
	var today = new Date();
	var eventsField = $('#contact-events')

	$('.form__datepicker').datepicker({
		format: 'dd/mm/yyyy',
		autoPick: false,
		autoHide: true,
		date: null,
		startDate: today
	});

	$('.form__select select').selectric();
	$('.selectric-input').wrap("<label hidden aria-hidden='true'>Hidden Label</label>")

	eventsField.on('change', function () {
		var accFields = $('.accommodation-fields')
		var option = $(this).find(":selected").text().toLowerCase()
		if (option !== 'accommodation') {
			accFields.css('display', 'none')
			return
		}
		accFields.css('display', 'block')

	})


}



function initVideoPopups() {
	var $modal;
	var modal = '<div id="gallery__modal" class="gallery__modal gallery__modal--video full reveal loading" data-reveal><button class="gallery__modal-close" data-close aria-label="Close modal" type="button"><span aria-hidden="true">Close</span></button><div class="gallery__modal-iframe"><iframe frameborder="0" src="{{iframeSrc}}"></iframe></div></div>';


	// Detect video links and embed them in a popup
	$('a[href*="youtu"], a[href*="vimeo.com"]').not('[href*="youtube.com/channel"]').addClass('is-video').on('click', function () {
		$modal = $( modal.replace('{{iframeSrc}}', generateVideoEmbedUrl($(this).attr('href'))) );

		$('body').append($modal);

		$('#gallery__modal').foundation();
		$('#gallery__modal').foundation('open');

		$('#gallery__modal').on('closed.zf.reveal', function () {
			$modal.remove();
		});

		return false;
	});
}


function generateVideoEmbedUrl(videoUrl) {
	if (videoUrl.indexOf('youtube.com/embed') > -1) {
		// already a YouTube embed code, return same link
		return videoUrl;
	} else if (videoUrl.indexOf('youtu') > -1) {
		// must be either a full or shortened YouTube url so parse and create embed link
		var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
		var match = videoUrl.match(regExp);

		if (match && match[2].length == 11) {
			return 'https://www.youtube.com/embed/' + match[2] + '?rel=0&autoplay=1&modestbranding=1';
		} else {
			return videoUrl;
		}
	} else if (videoUrl.indexOf('player.vimeo.com') > -1) {
		// already a Vimeo embed code, but add some parameters
		if ( videoUrl.indexOf('?') > -1 ) {
			videoUrl += '&';
		} else {
			videoUrl += '?';
		}
		return videoUrl + 'autoplay=true&byline=false&portrait=false&title=false';
	} else if (videoUrl.indexOf('https://vimeo.com/') > -1) {
		// normal Vimeo link, so generate and embed code
		return 'https://player.vimeo.com/video/' + videoUrl.split('/')[3] + '?autoplay=true&byline=false&portrait=false&title=false';
	}

	// if all else fails, return the original link
	return embedUrl;
}


function initGHAPortal() {
	$('.header__login-dropdown a').attr('tabindex', '-1').attr('aria-hidden', 'true');

	$('.header__login-button').on('click', function (e) {
		e.preventDefault();
		$('.header__login').toggleClass('open');
		if ($('.header__login').hasClass('open')) {
			trapFocus(document.querySelector('.header__login'));
			$('.header__login-dropdown a').attr('tabindex', '0').attr('aria-hidden', 'false');
		} else {
			untrapFocus(document.querySelector('.header__login'));
			$('.header__login-dropdown a').attr('tabindex', '-1').attr('aria-hidden', 'true');
		}
	});

	$('.header__login').on('mouseleave', function (e) {
		$('.header__login').removeClass('open');
		document.querySelector('.header__logo a').focus();
	});

	$('.gha__form input[type="password"]').each(function () {
    $(this).parent().append('<button type="button" class="toggle-password" aria-hidden="hidden" tabindex="-1"></button>');
  });

  $('.toggle-password').on('click', function () {
    var input = $(this).siblings('input')[0];
    if (typeof input !== 'undefined') {
      if (input.type === "password") {
        input.type = "text";
				$(this).addClass('off');
      } else {
				input.type = "password";
				$(this).removeClass('off');
      }
    }
  });

	$('.gha__form select').selectric();

	$('.gha__form select').each(function () {
    customSelectricPlaceholderState(this);
  });

  $('.gha__form select').on('change', function () {
    customSelectricPlaceholderState(this);
  });

  function customSelectricPlaceholderState(selectElement) {
    if ($(selectElement).val() === '') {
      $(selectElement).parents('.selectric-wrapper').addClass('show-as-placeholder');
    } else {
      $(selectElement).parents('.selectric-wrapper').removeClass('show-as-placeholder');
    }
  }

	$('.gha__form-clear').on('click', function (e) {
		e.preventDefault();
		$(this).parents('form').find('input').val('');
	});

	if ($('#gha-portal-tabs').length > 0 && window.location.hash.indexOf('#') === 0) {
		if (window.innerWidth < 640) {
			$('.gha-portal__main-tab-list').addClass('hidden');
		}
	}

	$('.gha-portal__main-tab-list a').on('click', function () {
		if (window.innerWidth < 640) {
			$('.gha-portal__main-tab-list').addClass('hidden');
		}
	});
	
	$('.tabs-panel__title').on('click', function (e) {
		e.preventDefault();
		$('.gha-portal__main-tab-list').removeClass('hidden');
	});

	$('.gha-sign-up form, #password form').on('submit', function () {
		if ($(this).find('input[type="password"]').length > 1) {
			return validateGHAPasswords($(this));
		}
	});

	$('.gha-sign-up input[type="password"]').on('input', function () {
		return validateGHAPasswords($(this).parents('form'));
	});

	$('.gha-sign-up input').on('input', function () {
		var input = $(this)[0];

		if ($(input).attr('pattern') !== '') {
			if (input.validity.patternMismatch) {
				input.setCustomValidity($(this).data('pattern-message'));
			} else {
				input.setCustomValidity('');
			}

			input.reportValidity();
		}
	});

	$('.gha__form-nav .next').on('click', function (e) {
		e.preventDefault();

		if ($(this).parents('form').find('input[type="password"]').length > 1) {
			if (!validateGHAPasswords($(this).parents('form'))) {
				return false;
			}
		}

		var invalidFieldCount = 0;

		$(this).parents('.gha-sign-up__form-wrapper').find('input, select').each(function () {
			if (!$(this)[0].reportValidity()) {
				invalidFieldCount++;
			}
		});

		if (invalidFieldCount === 0) {
			var $currentStepWrapper = $(this).parents('.gha-sign-up__form-wrapper');
			$currentStepWrapper.hide();
			var currentStepNumber = $currentStepWrapper.data('step');
			currentStepNumber++;
			$('.gha-sign-up__form-wrapper[data-step="' + currentStepNumber + '"]').show();
			$('html, body').animate({
				scrollTop: $('.gha-sign-up__form-wrapper[data-step="' + currentStepNumber + '"]').offset().top - 120
			}, 0);
		}
	});

	$('.gha__form-nav .back').on('click', function (e) {
		e.preventDefault();
		var $currentStepWrapper = $(this).parents('.gha-sign-up__form-wrapper');
		$currentStepWrapper.hide();
		var currentStepNumber = $currentStepWrapper.data('step');
		currentStepNumber--;
		$('.gha-sign-up__form-wrapper[data-step="' + currentStepNumber + '"]').show();
		$('html, body').animate({
			scrollTop: $('.gha-sign-up__form-wrapper[data-step="' + currentStepNumber + '"]').offset().top - 120
		}, 0);
	});
}

function validateGHAPasswords($form) {
	var isValid = true;
	$form.find('.requirement').removeClass('fail');

	var $currentStep = $('.gha-sign-up__form-wrapper:visible, .gha-portal');
	if ($currentStep.find('input[type="password"]').length === 0) {
		return true;
	}

	var $password1 = $('.gha-sign-up__form-wrapper:visible #password, #NewPassword');
	var $password2 = $currentStep.find('#confirmpassword, #ConfirmPassword');
	
	if ($password1.val() !== $password2.val()) {
		$currentStep.find('.requirement.match').addClass('fail');
		isValid = false;
	}

	if ($password1.val().length < 8 || $password1.val().length > 50) {
		$currentStep.find('.requirement.length').addClass('fail');
		isValid = false;
	}

	if (!/[a-z]/.test($password1.val().toLowerCase())) {
		$currentStep.find('.requirement.letter').addClass('fail');
		isValid = false;
	}

	if (!/\d/.test($password1.val())) {
		$currentStep.find('.requirement.number').addClass('fail');
		isValid = false;
	}

	if (!/[#.?!@$%^&*-]/.test($password1.val())) {
		$currentStep.find('.requirement.symbol').addClass('fail');
		isValid = false;
	}
	
	if (/[^\x20-\x7E]+/.test($password1.val())) {
		$currentStep.find('.requirement.ascii').addClass('fail');
		isValid = false;
	}
	
	return isValid;
}

document.addEventListener("DOMContentLoaded", function() {
    var memberships = document.querySelector(".memberships");
    var tabs = memberships.querySelectorAll(".tabs-title");
    var panels = memberships.querySelectorAll(".tabs-panel");
    var prevBtn = memberships.querySelector(".tabs-prev");
    var nextBtn = memberships.querySelector(".tabs-next");

    var currentIndex = 0;

    // Set initial active tab index based on "is-active" class
    for (var i = 0; i < tabs.length; i++) {
        if (tabs[i].classList.contains("is-active")) {
            currentIndex = i;
            break;
        }
    }

    function showPanel(index) {
        for (var i = 0; i < tabs.length; i++) {
            tabs[i].classList.remove("is-active");
            panels[i].classList.remove("is-active");
        }

        tabs[index].classList.add("is-active");
        panels[index].classList.add("is-active");
        currentIndex = index;
    }

    function showNextPanel() {
        var nextIndex = (currentIndex + 1) % panels.length;
        showPanel(nextIndex);
    }

    function showPrevPanel() {
        var prevIndex = (currentIndex - 1 + panels.length) % panels.length;
        showPanel(prevIndex);
    }

    nextBtn.addEventListener("click", showNextPanel);
    prevBtn.addEventListener("click", showPrevPanel);

    // Add click event listener to each tab
    tabs.forEach(function(tab, index) {
        tab.addEventListener("click", function() {
            showPanel(index);
        });
    });
});


// Selector for focusable elements
var focusableElementsSelector = 'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';

var tabTrappingHandler = function (event) {
	var focusableElements = event.currentTarget.focusableElements;

	// Check if the Tab key is pressed
	if (event.key === 'Tab') {
		var focusedElementIndex = focusableElements.indexOf(document.activeElement);

			if (event.shiftKey) {
					// Handle reverse tab (Shift + Tab)
					if (focusedElementIndex === 0) {
							// Prevent default behavior and move focus to the last element
							event.preventDefault();
							focusableElements[focusableElements.length - 1].focus();
					}
			} else {
					// Handle forward tab
					if (focusedElementIndex === focusableElements.length - 1) {
							// Prevent default behavior and move focus to the first element
							event.preventDefault();
							focusableElements[0].focus();
					}
			}
	}
};

// A ChatGPT script:
function trapFocus(parentElement) {
	// Get all focusable elements within the parent element
	var focusableElements = Array.from(parentElement.querySelectorAll(focusableElementsSelector));
	
	// Return early if no focusable elements found
	if (focusableElements.length === 0) {
			return;
	}

	// Add event listener for keydown events
	parentElement.focusableElements = focusableElements;
	parentElement.addEventListener('keydown', tabTrappingHandler);
}

function untrapFocus(parentElement) {
	parentElement.removeEventListener('keydown', tabTrappingHandler);
}

function accessibleNavigation() {
	/* var trapThese = Array.from(document.querySelectorAll('.header__login'));

	for (var i = 0; i < trapThese.length; i++) {
		trapFocus(trapThese[i]);
	} */
}

function onRecaptchaLoadCallback() {
    
	var $recaptchaSubmit = document.querySelector('.g-recaptcha');
	
	if ($recaptchaSubmit != null) {
		
		var clientId = grecaptcha.render('recaptcha_badge_container', {
			'sitekey': $recaptchaSubmit.dataset.sitekey,
			'badge': 'bottomright',
			'size': 'invisible'
		});

		grecaptcha.ready(function() {
			var $recaptchaField = document.createElement("input");
			$recaptchaField.setAttribute('type', 'hidden');
			$recaptchaField.setAttribute('id', 'g-Recaptcha-Response');
			$recaptchaField.setAttribute('name', 'g-Recaptcha-Response');
			
			$recaptchaSubmit.closest('form').appendChild($recaptchaField);
				
			setUpdateValue(clientId, $recaptchaSubmit, $recaptchaField);
		});
	}
}
	
function setUpdateValue(clientId, $recaptchaSubmit, $recaptchaField) {				
	grecaptcha.execute(clientId, {
		action: $recaptchaSubmit.dataset.action
	})
	.then(function(token) {
		$recaptchaField.setAttribute('value', token);
	});
	
	setTimeout(function() { setUpdateValue(clientId, $recaptchaSubmit, $recaptchaField); }, 60*1000);
}